export enum MeasuringRoller {
    Series = 'measuring_roller.series',
    Size = 'measuring_roller.size',
}
